export default __webpack_public_path__ + "static/instant-push-phone-af7cdfd4b299d97890e09d3d9a38193f.webp";